(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaffio-blog-hub"]) return;
  try {
    
  function initKaffioBlogTopics(root) {
    root.querySelectorAll('[data-kaffio-blog-hub]').forEach(function(hub) {
      if (hub.dataset.topicsReady === 'true') return;
      hub.dataset.topicsReady = 'true';
      var nav = hub.querySelector('[data-blog-topics]');
      var cards = Array.from(hub.querySelectorAll('[data-blog-card]'));
      var empty = hub.querySelector('[data-blog-empty]');
      if (!nav || !cards.length) return;
      nav.querySelectorAll('[data-blog-topic]').forEach(function(button) {
        var topic = button.dataset.blogTopic;
        if (topic !== 'alle') button.hidden = !cards.some(function(card) { return card.dataset.blogCategory === topic; });
      });
      nav.hidden = false;
      nav.addEventListener('click', function(event) {
        var button = event.target.closest('[data-blog-topic]');
        if (!button || !nav.contains(button)) return;
        var topic = button.dataset.blogTopic;
        var visible = 0;
        nav.querySelectorAll('[data-blog-topic]').forEach(function(item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function(card) {
          var show = topic === 'alle' || card.dataset.blogCategory === topic;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  }
  initKaffioBlogTopics(document);
  document.addEventListener('shopify:section:load', function(event) { initKaffioBlogTopics(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaffio-cart-design"] && !Shopify.designMode) return;
  try {
    
  const refreshKaffioCartProgress = async () => {
    const roots = document.querySelectorAll('[data-kfy-cart-progress]');
    if (!roots.length) return;

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();

      roots.forEach((root) => {
        const threshold = Number(root.dataset.threshold);
        const remaining = threshold - cart.total_price;
        const progress = Math.min(100, Math.max(0, cart.total_price * 100 / threshold));
        const currency = cart.currency || 'EUR';
        const locale = document.documentElement.lang || 'de';
        const amount = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Math.max(0, remaining) / 100);
        const message = remaining > 0
          ? root.dataset.remainingTemplate.replace('__AMOUNT__', amount)
          : root.dataset.reachedTemplate;
        const messageNode = root.querySelector('[data-kfy-shipping-message]');
        const bar = root.querySelector('[data-kfy-shipping-bar]');
        const progressbar = root.querySelector('[role="progressbar"]');

        root.hidden = cart.item_count === 0;
        if (messageNode) messageNode.textContent = message;
        if (bar) bar.style.setProperty('--kfy-progress', `${progress}%`);
        if (progressbar) {
          progressbar.setAttribute('aria-valuenow', String(Math.round(progress)));
          progressbar.setAttribute('aria-valuetext', message);
        }
      });
    } catch {}
  };

  let kaffioCartProgressTimer;
  const scheduleKaffioCartProgress = () => {
    window.clearTimeout(kaffioCartProgressTimer);
    kaffioCartProgressTimer = window.setTimeout(refreshKaffioCartProgress, 900);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"]')) scheduleKaffioCartProgress();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.quantity__button, cart-remove-button')) scheduleKaffioCartProgress();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaffio-collection-design"]) return;
  try {
    
  const kaffioCollectionConfig = document.querySelector('[data-kfy-collection-config]');

  if (kaffioCollectionConfig && !window.kaffioCollectionUxReady) {
    window.kaffioCollectionUxReady = true;

    const kaffioTexts = kaffioCollectionConfig.dataset;
    const kaffioRoot = window.Shopify?.routes?.root || '/';
    const kaffioToast = document.querySelector('[data-kfy-cart-toast]');
    const kaffioToastHeading = kaffioToast?.querySelector('[data-kfy-toast-heading]');
    const kaffioToastProduct = kaffioToast?.querySelector('[data-kfy-toast-product]');
    let kaffioToastTimer;
    let kaffioScrollRestoreTimers = [];
    let kaffioScrollRestoreCancelled = false;

    const kaffioCollectionLocation = () => `${window.location.pathname}${window.location.search}`;

    const kaffioClearScrollRestore = () => {
      kaffioScrollRestoreTimers.forEach((timer) => window.clearTimeout(timer));
      kaffioScrollRestoreTimers = [];
    };

    const kaffioCancelScrollRestore = () => {
      kaffioScrollRestoreCancelled = true;
      kaffioClearScrollRestore();
    };

    const kaffioSaveCollectionPosition = (link) => {
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;

      const currentState = window.history.state && typeof window.history.state === 'object'
        ? window.history.state
        : {};

      window.history.replaceState({
        ...currentState,
        kaffioCollectionScroll: {
          path: kaffioCollectionLocation(),
          top: Math.max(0, Math.round(window.scrollY)),
          savedAt: Date.now()
        }
      }, document.title, window.location.href);
    };

    const kaffioRestoreCollectionPosition = () => {
      const saved = window.history.state?.kaffioCollectionScroll;
      if (!saved || saved.path !== kaffioCollectionLocation() || !Number.isFinite(saved.top)) return;

      kaffioClearScrollRestore();
      kaffioScrollRestoreCancelled = false;

      [0, 120, 350, 750, 1400, 2400].forEach((delay) => {
        const timer = window.setTimeout(() => {
          if (kaffioScrollRestoreCancelled || !document.querySelector('#gf-products .spf-product-card')) return;
          const maximumTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
          window.scrollTo({ top: Math.min(saved.top, maximumTop), left: 0, behavior: 'auto' });
        }, delay);
        kaffioScrollRestoreTimers.push(timer);
      });
    };

    const kaffioSetText = (element, value) => {
      if (element && element.textContent.trim() !== value) element.textContent = value;
    };

    const kaffioHideToast = () => {
      if (!kaffioToast) return;
      kaffioToast.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!kaffioToast.classList.contains('is-visible')) kaffioToast.hidden = true;
      }, 180);
    };

    const kaffioShowToast = (heading, productTitle = '', isError = false) => {
      if (!kaffioToast) return;
      window.clearTimeout(kaffioToastTimer);
      kaffioSetText(kaffioToastHeading, heading);
      kaffioSetText(kaffioToastProduct, productTitle);
      kaffioToast.setAttribute('aria-live', isError ? 'assertive' : 'polite');
      kaffioToast.hidden = false;
      window.requestAnimationFrame(() => kaffioToast.classList.add('is-visible'));
      kaffioToastTimer = window.setTimeout(kaffioHideToast, isError ? 7000 : 5500);
    };

    const kaffioUpdateCartCount = (count) => {
      const link = document.querySelector('.kfy-header-actions a[href*="/cart"]');
      const label = link?.querySelector('span');
      if (!link || !label) return;
      label.textContent = count > 0 ? `${kaffioTexts.cart} (${count})` : kaffioTexts.cart;
      link.setAttribute('aria-label', label.textContent);
    };

    const kaffioEnhanceCards = () => {
      document.querySelectorAll('#gf-products .spf-product-card').forEach((card) => {
        const form = card.querySelector('.spf-product__form');
        const addButton = form?.querySelector('.spf-product__form-btn-addtocart');
        const addLabel = addButton?.querySelector('span');
        const soldOut = card.classList.contains('spf-soldout');
        const soldOutLabel = card.querySelector('.spf-product__label-soldout');

        if (!form || !addButton) return;

        if (soldOut) {
          kaffioSetText(soldOutLabel, kaffioTexts.unavailable);
          kaffioSetText(addLabel, kaffioTexts.unavailable);
          if (!addButton.disabled) addButton.disabled = true;
          form.querySelector('.kfy-buy-now')?.remove();
          return;
        }

        if (!addButton.hasAttribute('aria-busy')) kaffioSetText(addLabel, kaffioTexts.add);

        let buyNow = form.querySelector('.kfy-buy-now');
        if (!buyNow) {
          buyNow = document.createElement('button');
          buyNow.type = 'button';
          buyNow.className = 'kfy-buy-now';
          buyNow.textContent = kaffioTexts.buyNow;
          form.append(buyNow);
        }

        if (buyNow.disabled !== addButton.disabled) buyNow.disabled = addButton.disabled;
      });
    };

    const kaffioAddProduct = async (form, checkout = false) => {
      if (form.dataset.kfyLoading === 'true') return;

      const addButton = form.querySelector('.spf-product__form-btn-addtocart');
      const addLabel = addButton?.querySelector('span');
      const buyNow = form.querySelector('.kfy-buy-now');
      if (!addButton || addButton.disabled) return;

      form.dataset.kfyLoading = 'true';
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      if (buyNow) buyNow.disabled = true;
      kaffioSetText(addLabel, kaffioTexts.adding);

      try {
        const response = await fetch(`${kaffioRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || kaffioTexts.error);

        if (checkout) {
          window.location.assign(`${kaffioRoot}checkout`);
          return;
        }

        const cartResponse = await fetch(`${kaffioRoot}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          kaffioUpdateCartCount(cart.item_count);
        }

        kaffioSetText(addLabel, kaffioTexts.added);
        kaffioShowToast(kaffioTexts.added, item.product_title || item.title || '');
      } catch (error) {
        kaffioShowToast(kaffioTexts.error, error.message === kaffioTexts.error ? '' : error.message, true);
      } finally {
        window.setTimeout(() => {
          form.dataset.kfyLoading = 'false';
          addButton.removeAttribute('aria-busy');
          if (!form.closest('.spf-soldout')) {
            addButton.disabled = false;
            kaffioSetText(addLabel, kaffioTexts.add);
            if (buyNow) buyNow.disabled = false;
          }
        }, 1200);
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('#gf-products .spf-product__form');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      kaffioAddProduct(form);
    }, true);

    document.addEventListener('click', (event) => {
      const buyNow = event.target.closest('#gf-products .kfy-buy-now');
      const closeToast = event.target.closest('[data-kfy-toast-close]');
      const productLink = event.target.closest('#gf-products a[href*="/products/"]');

      if (productLink) kaffioSaveCollectionPosition(productLink);

      if (buyNow) {
        event.preventDefault();
        event.stopImmediatePropagation();
        kaffioAddProduct(buyNow.closest('form'), true);
      }

      if (closeToast) kaffioHideToast();
    }, true);

    let kaffioEnhanceQueued = false;
    const kaffioScheduleEnhance = () => {
      if (kaffioEnhanceQueued) return;
      kaffioEnhanceQueued = true;
      window.requestAnimationFrame(() => {
        kaffioEnhanceQueued = false;
        kaffioEnhanceCards();
      });
    };

    const kaffioGridRoot = document.querySelector('#ProductGridContainer') || document.body;
    const kaffioObserver = new MutationObserver(kaffioScheduleEnhance);
    kaffioObserver.observe(kaffioGridRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });

    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, kaffioCancelScrollRestore, { passive: true });
    });
    window.addEventListener('pageshow', kaffioRestoreCollectionPosition);

    kaffioEnhanceCards();
    kaffioRestoreCollectionPosition();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaffio-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.kfy-nav-details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.kfy-nav-details[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary')?.focus();
  });
});

  } catch(e) { console.error(e); }
})();
})();
